;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      user_email: null,
      user_id: null,
      old_pwd: null,
      consumer_secret: null,
      consumer_key: null
    };
  },

  mounted: function mounted() {
    this.consumer_secret = this.$attrs["con_secret"];
    this.consumer_key = this.$attrs["con_key"];
  },
  created: function created() {
    this.user_email = this.$attrs["email"];
    this.user_id = this.$attrs["userid"];
  },
  methods: {
    verifyPwdChange: function verifyPwdChange() {
      if (this.old_pwd == null) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Forgot something ? Enter your current Pin"
        });
        return;
      }
      this.getOauthToken();
    },
    getOauthToken: function getOauthToken() {
      var _this = this;

      var url = "/api/oauth/generate/token";
      var payload = {
        secret: this.consumer_secret,
        key: this.consumer_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this.commitPwdChange(response.data.token);
      }).catch(function (error) {}).then(function () {});
    },
    commitPwdChange: function commitPwdChange(token) {
      var urlIs = "/api/agent/pin/verify_and_change";
      var api_headers = {
        Authorization: "Bearer " + token
      };

      var api_params = {
        id: this.user_id,
        current_pin: this.old_pwd
      };
      Vue.axios.post(urlIs, api_params, {
        headers: api_headers
      }).then(function (response) {
        if (response.data.status == 422) {
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "An error occurred during processing. If this persists, contact customer support for assistance"
          });
        } else if (response.data.status == 400) {
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "Invalid  Current PIN specified"
          });
        } else {
          _sweetalert2.default.fire({
            position: "top-end",
            icon: "success",
            title: "Your PIN has been changed",
            showConfirmButton: false,
            timer: 2500
          });
        }
      }).catch(function (error) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!"
        });
      }).then(function () {});
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Current Pin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.old_pwd),expression:"old_pwd"}],staticClass:"form-control",attrs:{"type":"password"},domProps:{"value":(_vm.old_pwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.old_pwd=$event.target.value}}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('input',{staticClass:"btn btn-primary lift",attrs:{"type":"button","value":"Generate New Pin"},on:{"click":_vm.verifyPwdChange}})])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('h3',{staticClass:"mb-2"},[_vm._v("PIN")]),_vm._v(" "),_c('label',{staticClass:"mb-5 text-muted"},[_vm._v("Your PIN is private. Change or update your pin often.")])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Your New Pin will be automatically generated")])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2d47de3c", __vue__options__)
  } else {
    hotAPI.reload("data-v-2d47de3c", __vue__options__)
  }
})()}